module.exports = __webpack_public_path__ + "img/lianxi_normal.62bd957a.png";